export const money = (val: number, currency: string) =>
  val === null
    ? ''
    : new Intl.NumberFormat(navigator.language, {
        style: 'currency',
        currency
      }).format(val / 100);

export const percentage = val => `${val}%`;
